module.exports = __webpack_public_path__ + "static/media/10.8c0a0d5d.jpg";